import styled from 'styled-components';


export const ButtonContent = styled.span`
  padding: ${ ( { theme } ) => theme.spacing07 } ${ ( { theme } ) => theme.spacing06 };
  white-space: nowrap;
`;

export default ButtonContent;
